import apiFetch from '../apiFetch'

export default function (idAnalisisExtraccion) {
  return apiFetch({endPoint: `Analisis/cambiarAnalisisEyaculadoEliminado?idAnalisis=${idAnalisisExtraccion}`, method: 'GET', body: null})
}
